module.exports = __webpack_public_path__ + "img/g-img.142fbf6b.svg";